import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/frontend/frontend/apps/web/app/datadog-init.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LazyDebugToolbar"] */ "/home/runner/work/frontend/frontend/apps/web/app/lazy-debug-toolbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LazyHeadlessModeWarning"] */ "/home/runner/work/frontend/frontend/apps/web/app/lazy-headless-mode-warning.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProgressBar"] */ "/home/runner/work/frontend/frontend/apps/web/app/progress-bar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/home/runner/work/frontend/frontend/apps/web/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/frontend/frontend/packages/core/dist/index.css");
